import { useCallback, useEffect } from "react"
import { Controller, useFormContext, useWatch } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import useColors from "@hooks/useColors"
import { useDropzone } from "react-dropzone"
import { SubscriptionsAction } from "@store/actions"
import HelperText from "@components/form/helper-text"
import { ColorPicker, Space } from "antd"
import { DEFAULT_USER_COLORS } from "@config/colors"
import SelectField from "@components/TextField/SelectField"
import { Colors } from "chart.js"
import StarDrop from '@assets/images/star-drop.svg'

export default function Step3() {
    const { control, setValue, formState: { errors } } = useFormContext()
    const dispatch = useDispatch()
    const files = useWatch({ name: 'files' })
    const subscriptions = useSelector(store => store.SubscriptionsReducer.data)
    console.log("subscriptions", subscriptions)

    const onDrop = useCallback(acceptedFiles => {
        setValue('files', acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
        })));
    }, [])

    const { colorPrimary } = useColors()

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    useEffect(() => {
        dispatch(SubscriptionsAction.GetSubscriptions())
    }, [])

    return (
        <>
            <h6 className="font-bold text-center text-[16px]">Insert your logo</h6>
            <div {...getRootProps()} style={{ backgroundColor: Colors.LightGray }} className="px-6 py-2 flex items-center gap-4 cursor-pointer rounded-xl relative">
                <input {...getInputProps()} />

                <img src={files?.[0]?.preview ?? StarDrop} alt="Upload" className="w-20 aspect-square rounded-lg object-contain" />
                {
                    isDragActive ? <div className="rounded-xl font-medium absolute inset-0 border-[2px] h-full w-full border-dashed border-neutral-400 flex items-center justify-center">Drop your files here...</div> :
                        files?.length > 0 ? (
                            <div className="flex-1 flex justify-between items-center">
                                <p className="mb-0 font-medium text-[16px] truncate max-w-[200px]">{files[0]?.name || "Logo selected"}</p>
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setValue('files', null, { shouldValidate: true });
                                    }}
                                    className="text-red-500 font-medium hover:text-red-600 bg-red-50 px-3 py-1 rounded-md"
                                >
                                    Remove
                                </button>
                            </div>
                        ) : (
                            <p className="mb-0 font-medium text-[16px]">Drag your logo here or <span style={{ color: colorPrimary }} className="underline">Browse</span></p>
                        )
                }
            </div>
            {errors?.files && <HelperText type="danger">{errors?.files?.message}</HelperText>}
            <div className="py-4">
                <h6 className="font-bold text-center mb-2 text-[16px]">Choose your colors</h6>
                <Space className="w-full justify-center flex-wrap">
                    {Object.entries(DEFAULT_USER_COLORS).map(([key, val]) => {
                        return <div key={key} xs={8} className="flex flex-col items-center gap-1">
                            <span className="capitalize text-xs font-medium">{key}</span>
                            <Controller
                                name={`colors.${key}`}
                                control={control}
                                render={({ field: { onChange, value } }) => {
                                    return (
                                        <ColorPicker value={value} onChangeComplete={(v) => {
                                            onChange(typeof v === 'string' ? v : v?.toHexString())
                                        }} showText format="hex" />
                                    )
                                }}
                            />
                        </div>
                    })}
                </Space>
            </div>
            {/* <div className="py-4">
                <h6 className="font-bold text-center mb-2 text-[16px]">Choose your subscription plan</h6>
                <Controller
                    name="subscriptionId"
                    control={control}
                    render={({ field: { onChange, value }, fieldState }) => {
                        return (
                            <>
                                <SelectField
                                    className="w-full rounded-full overflow-hidden h-14"
                                    placeholder="Select Your Subscription Package"
                                    value={value}
                                    onChange={(v) => onChange(v)}
                                    options={subscriptions?.map(sub => ({
                                        label: sub.name,
                                        value: sub.id
                                    }))}
                                />
                                {fieldState?.error && <HelperText type="danger">{fieldState?.error.message}</HelperText>}
                            </>
                        )
                    }}
                />
            </div> */}
            {/* <h6 className="font-bold text-center">Choose subscription plan</h6> */}
            <p className="text-xs text-gray-500 text-center">Change logo and colors from the settings menu at any time</p>
            <p className="text-xs text-gray-500 text-center">By creating an account, you are agreeing to the GuardsConnect Terms of Service and acknowledging our Privacy Policy.</p>
        </>
    );
}